// src/MobileHamburger.js
import React from 'react';
import { FaBars, FaXmark } from 'react-icons/fa6';

export default function MobileHamburger({ isOpen, onToggle, className = '' }) {
  return (
    <button
      onClick={onToggle}
      className={`mobile-hamburger ${className}`}
      title={isOpen ? 'Close Menu' : 'Open Menu'}
      aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
    >
      {isOpen ? <FaXmark /> : <FaBars />}
    </button>
  );
} 